module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"mt-5 mb-6 card border-0\"> <div class=\"my-6\"> <div class=\"row\"> <div class=\"col-md-6 mx-auto text-center\"> <div id=\"account_balance\"></div> <div id=\"price_per_shipment\"></div> </div> </div> </div> <div id=\"subscriptions\"></div> <div id=\"payment_methods\"></div> </div> <div class=\"my-7\"> <div id=\"payment_logs\"></div> </div> <div class=\"my-7\"> <div id=\"cash_flow\"></div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/template.ejs
// module id = 1282
// module chunks = 1